import { useState, useEffect } from 'react';
import { categories } from '@/mocks/categories';
import { Link, useNavigate } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <span className={`font-heading text-xl font-bold whitespace-nowrap transition-colors ${scrolled ? 'text-foreground-900' : 'text-white'}`}>
              Kakobuy<span className="text-accent-500">Spreadsheet</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-5">
            <button
              onClick={() => { navigate('/'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
              className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${scrolled ? 'text-foreground-700 hover:text-primary-600' : 'text-white/90 hover:text-white'}`}
            >
              <i className="ri-home-4-line mr-1"></i>Strona główna
            </button>
            <a href="#czym-jest" className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${scrolled ? 'text-foreground-700 hover:text-primary-600' : 'text-white/90 hover:text-white'}`}>
              Czym jest?
            </a>
            <button
              onClick={() => navigate('/artykul/kakobuy-spreadsheet-poradnik')}
              className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${scrolled ? 'text-foreground-700 hover:text-primary-600' : 'text-white/90 hover:text-white'}`}
            >
              <i className="ri-book-3-line mr-1"></i>Poradnik zakupowy
            </button>
            <a href="#kategorie" className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${scrolled ? 'text-foreground-700 hover:text-primary-600' : 'text-white/90 hover:text-white'}`}>
              Kategorie
            </a>
            <a href="#bezpieczenstwo" className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${scrolled ? 'text-foreground-700 hover:text-primary-600' : 'text-white/90 hover:text-white'}`}>
              Bezpieczeństwo
            </a>
            <a href="#artykuly" className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${scrolled ? 'text-foreground-700 hover:text-primary-600' : 'text-white/90 hover:text-white'}`}>
              Artykuły
            </a>

            <div className="relative">
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                  scrolled
                    ? 'bg-primary-500 text-white hover:bg-primary-600'
                    : 'bg-white/20 text-white hover:bg-white/30 backdrop-blur-sm'
                }`}
              >
                Kategorie {dropdownOpen ? <i className="ri-arrow-up-s-line text-sm"></i> : <i className="ri-arrow-down-s-line text-sm"></i>}
              </button>

              {dropdownOpen && (
                <>
                  <div className="fixed inset-0 z-40" onClick={() => setDropdownOpen(false)}></div>
                  <div className="absolute right-0 mt-2 w-72 bg-background-50 rounded-xl border border-background-200/70 z-50 py-2 max-h-[450px] overflow-y-auto">
                    <div className="px-4 py-2 border-b border-background-100">
                      <p className="text-xs font-semibold text-foreground-500 uppercase tracking-wide">Kategorie produktów</p>
                    </div>
                    {categories.map((cat) => (
                      <a
                        key={cat.id}
                        href={cat.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600">
                          <i className={`${cat.icon} text-sm`}></i>
                        </span>
                        {cat.name}
                        <i className="ri-external-link-line text-xs text-foreground-400 ml-auto"></i>
                      </a>
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${scrolled ? 'text-foreground-800' : 'text-white'}`}
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 max-h-[80vh] overflow-y-auto">
          <div className="px-4 py-4 space-y-1">
            <button
              onClick={() => { setMobileMenuOpen(false); navigate('/'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
              className="flex items-center gap-3 w-full text-sm font-semibold text-foreground-800 py-3 px-2 rounded-lg hover:bg-primary-50 cursor-pointer"
            >
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                <i className="ri-home-4-line"></i>
              </span>
              Strona główna
            </button>
            <a href="#czym-jest" onClick={() => setMobileMenuOpen(false)} className="flex items-center gap-3 text-sm font-medium text-foreground-700 py-3 px-2 rounded-lg hover:bg-primary-50 cursor-pointer">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600">
                <i className="ri-question-line"></i>
              </span>
              Czym jest Kakobuy?
            </a>
            <button
              onClick={() => { setMobileMenuOpen(false); navigate('/artykul/kakobuy-spreadsheet-poradnik'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
              className="flex items-center gap-3 w-full text-sm font-medium text-foreground-700 py-3 px-2 rounded-lg hover:bg-primary-50 cursor-pointer"
            >
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600">
                <i className="ri-book-3-line"></i>
              </span>
              Poradnik zakupowy
            </button>
            <a href="#kategorie" onClick={() => setMobileMenuOpen(false)} className="flex items-center gap-3 text-sm font-medium text-foreground-700 py-3 px-2 rounded-lg hover:bg-primary-50 cursor-pointer">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600">
                <i className="ri-grid-line"></i>
              </span>
              Kategorie
            </a>
            <a href="#bezpieczenstwo" onClick={() => setMobileMenuOpen(false)} className="flex items-center gap-3 text-sm font-medium text-foreground-700 py-3 px-2 rounded-lg hover:bg-primary-50 cursor-pointer">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600">
                <i className="ri-shield-check-line"></i>
              </span>
              Bezpieczeństwo
            </a>
            <a href="#artykuly" onClick={() => setMobileMenuOpen(false)} className="flex items-center gap-3 text-sm font-medium text-foreground-700 py-3 px-2 rounded-lg hover:bg-primary-50 cursor-pointer">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600">
                <i className="ri-article-line"></i>
              </span>
              Artykuły SEO
            </a>
          </div>

          <div className="px-4 py-4 border-t border-background-200/70 bg-background-100">
            <div className="flex items-center gap-2 mb-3">
              <i className="ri-shopping-bag-3-line text-sm text-foreground-500"></i>
              <p className="text-xs font-semibold text-foreground-500 uppercase">Kategorie produktów</p>
            </div>
            <div className="grid grid-cols-2 gap-1.5">
              {categories.map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex items-center gap-2 py-2 px-2 text-xs text-foreground-600 hover:text-primary-600 hover:bg-primary-50 rounded-lg cursor-pointer whitespace-nowrap transition-colors"
                >
                  <span className="w-6 h-6 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-500 flex-shrink-0">
                    <i className={`${cat.icon} text-[10px]`}></i>
                  </span>
                  <span className="truncate">{cat.name}</span>
                </a>
              ))}
            </div>
          </div>

          <div className="px-4 py-4 border-t border-background-200/70">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center justify-center gap-2 w-full py-3 bg-accent-500 hover:bg-accent-600 text-white font-semibold rounded-full text-sm transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-shopping-cart-2-line"></i> Kakobuy Spreadsheet
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}